import { styled } from 'styled-components';

export const SortableTableContainer = styled.div`
  overflow-x: auto;
  border: ${({ $withBorderOuter, theme }) =>
    $withBorderOuter
      ? // eslint-disable-next-line max-len
        `0px solid transparent; border-right: 1px solid ${theme.colours.canvas.primary.main}; border-bottom: 1px solid ${theme.colours.canvas.primary.main}; border-left: 1px solid ${theme.colours.canvas.primary.main};`
      : 'none'};
  ${({ $isHeadSticky, $nonTableHeight }) =>
    $isHeadSticky &&
    `max-height: ${$nonTableHeight || 'calc(100vh - 34.5rem)'};`}

  // hide corner-square when overflow-x and overflow-y being used simultaneously
    ::-webkit-scrollbar-corner {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colours.layering[1].strong};
  }

  table {
    border: ${({ $withBorder, theme }) =>
      $withBorder
        ? `1px solid ${theme.colours.canvas.secondary.weak}`
        : 'none'};
  }
  tbody {
    tr td {
      height: ${({ $rowHeight }) => $rowHeight || '2rem'};

      &.hasChevron {
        font-weight: bold;
        text-transform: capitalize;

        button {
          position: absolute;
          top: 0.25rem;
          right: 0.25rem;
        }
      }
    }
    tr:hover td {
      background-color: ${({ theme }) => theme.colours.canvas.secondary.strong};

      .hover-svg {
        svg {
          background-color: ${({ theme }) =>
            theme.colours.canvas.secondary.strong};
        }
      }
    }
  }
  tfoot {
    position: ${({ $isHeadSticky }) => $isHeadSticky && 'sticky'};
    top: 0;
    bottom: 0;
    inset-block-start: 0;
    inset-block-end: 0;
    z-index: 3;

    tr td {
      background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
      color: ${({ theme }) =>
        theme.applyOpacity(theme.colours.ink.primary.main, 'secondary')};
      border-top: 2px solid ${({ theme }) => theme.colours.interface.main};
      font-weight: 600;
      height: ${({ $rowHeight }) => $rowHeight || '2rem'};
    }
  }

  a {
    text-decoration: underline;
  }
`;

SortableTableContainer.displayName = 'SortableTableContainer';

export const HeaderWithButtons = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;

  .dropdown-content {
    display: none;
    position: absolute;
    background-color: ${({ theme }) => theme.colours.canvas.tertiary.main};
    border-color: ${({ theme }) => theme.colours.canvas.primary.main};
    border-width: 1px;
    border-style: solid;
    border-radius: ${({ theme }) => theme.borderRadius.tertiary};
    width: 100%;
    top: 16px;
    padding: ${({ theme }) => `${theme.sizing.tiny} ${theme.sizing.small}`};
    min-width: 74px;
    z-index: 1;
  }

  .dropdown-content > button {
    margin-left: ${({ theme }) => theme.sizing.small};
    float: left;
  }
  .dropdown-content > button:first-child {
    margin-left: 0px;
  }

  &:hover .dropdown-content {
    display: block;
  }
`;
HeaderWithButtons.displayName = 'HeaderWithButtons';

export const TableHeadWrapper = styled.div`
  thead {
    th {
      height: 40px;
    }
  }
`;
TableHeadWrapper.displayName = 'TableHeadWrapper';

// change the background colour for an inline menu within a table from the default provided by KB
export const ButtonWithMenuWrapper = styled.div`
  display: block;

  li {
    background-color: ${({ theme }) =>
      theme.colours.canvas.secondary.weak} !important;

    &:hover {
      background-color: ${({ theme }) =>
        theme.colours.canvas.secondary.main} !important;
    }
  }
`;
ButtonWithMenuWrapper.displayName = 'ButtonWithMenuWrapper';

export const TableStarWrapper = styled.div`
  svg {
    color: ${({ theme, $filled }) =>
      $filled
        ? theme.colours.messaging.warning.main
        : theme.applyOpacity(theme.colours.graphics.primary.main, 'overlay')};
  }
`;
TableStarWrapper.displayName = 'TableStarWrapper';

export const IconWarningColour = styled.div`
  svg {
    color: ${({ theme }) => theme.colours.messaging.warning.main};
  }
`;
IconWarningColour.displayName = 'IconWarningColour';
